module.exports = __webpack_public_path__ + "img/coruja.58621d7d.svg";